import { SecGroupDescriptor } from '../../secgroup/model/secgroup';
import { FormDescriptor } from '../../form/model/form';
import { ProfileModel } from '../../profile/model/profile.model';
import { ModuleModel } from '../../module.model.interface';

export const RelatedObjectType_Profile = 'Profile';
export const RelatedObjectType_Form = 'Form';

export class SecGroupRelationDescriptor implements ModuleModel {
  public discriminator = 'SecGroupRelationDescriptor';
  public id: string;
  public secGroupId: string;
  public relatedObjectId: string;
  public relatedObjectType: string;
  public validFrom: Date;
  public validUntil?: Date;

  public href: string;
  public modified: Date;
  public deleted: Date;

  public secGroupDetail: SecGroupDescriptor;
  public secGroupName: string;
  public profileDetail: ProfileModel;
  public profileName: string;
  public formDetail: FormDescriptor;
  public formName: string;

  public relatedObjectTitle: string;

  constructor(options?: {
    id: string;
    secGroupId: string;
    relatedObjectId: string;
    relatedObjectType: string;
    validFrom: Date;
    validUntil?: Date;

    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;
      this.secGroupId = options.secGroupId;
      this.relatedObjectId = options.relatedObjectId;
      this.relatedObjectType = options.relatedObjectType;
      this.validFrom = options.validFrom;
      this.validUntil = options.validUntil;
      this.href = options.href;
      this.modified = options.modified;
      this.deleted = options.deleted;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/secgroup.relation/model/secgroup.relation.ts